import * as types from './actionTypes'
import { driversPagination } from '../../utils/constants'

export const initialState = {
  drivers: [],
  hasMoreDrivers: true,
  recentCreatedDrivers: [],
}

const Drivers = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_DRIVER: {
      if (payload.pagination) {
        return {
          ...state,
          drivers: [...state.drivers, ...payload.result],
          hasMoreDrivers: payload.result.length >= driversPagination,
        }
      }
      return {
        ...state,
        drivers: payload.result,
        hasMoreDrivers: payload.result.length >= driversPagination,
      }
    }
    case types.CLEAR_DRIVERS: {
      return {
        ...state,
        drivers: [],
        hasMoreDrivers: false,
      }
    }
    case types.FETCH_RECENT_DRIVERS: {
      return {
        ...state,
        recentCreatedDrivers: payload,
      }
    }
    default:
      return state
  }
}

export default Drivers
